module.exports = __webpack_public_path__ + "img/DK38722557.fadcdf20.png";